import type { UserInterest } from "./tanstack-query/dtos/user.dto";

const EVENT_PREFIX = "ctlz_";

export const ANALYTICS_EVENTS = {
  /** Signed up */
  SIGN_UP: "sign_up",

  /** Created a project */
  PROJECT_CREATED: "project_created",

  /** Showing interest by clicking on "express interest" or "support" button */
  FUNDING_INTEREST: "funding_interest",
  /** Creating a funding intent */
  FUNDING_INTENT: "funding_intent",
  /** Starting a stripe/chariot checkout session */
  FUNDING_DONATION_STARTED: "funding_donation_started",
  /** Applied a search fallback suggestion */
  SEARCH_SUGGESTION_APPLIED: "search_suggestion_applied",
  /** User initiated a share (minted a ShareLink) */
  SHARE_STARTED: "share_started",
  /** Inbound referral code captured from URL */
  REFERRAL_CAPTURED: "referral_captured",

  // NSF pilot outreach. Only companySlug and the signup id are ever sent:
  // the whole point of a token in the link is that no address reaches GTM.
  NSF_PILOT_LINK_OPENED: "nsf_pilot_link_opened",
  NSF_PILOT_INTERESTS_EDITED: "nsf_pilot_interests_edited",
  NSF_PILOT_ACCOUNT_CLAIMED: "nsf_pilot_account_claimed",

  // Unified discovery (plan section 9)
  DISCOVER_VIEWED: "discover_viewed",
  DISCOVER_QUERY_SUBMITTED: "discover_query_submitted",
  DISCOVER_THEME_SELECTED: "discover_theme_selected",
  DISCOVER_FILTER_APPLIED: "discover_filter_applied",
  DISCOVER_SORT_CHANGED: "discover_sort_changed",
  DISCOVER_RESULT_CLICKED: "discover_result_clicked",
  DISCOVER_SECTION_SEE_ALL: "discover_section_see_all",

  // Personalization funnel (plan section 9)
  PERSONALIZE_STARTED: "personalize_started",
  PERSONALIZE_STEP_COMPLETED: "personalize_step_completed",
  PERSONALIZE_STEP_SKIPPED: "personalize_step_skipped",
  PERSONALIZE_PREPARATION_COMPLETED: "personalize_preparation_completed",
  PERSONALIZE_PREPARATION_TIMED_OUT: "personalize_preparation_timed_out",
  PERSONALIZE_EMAIL_SUBMITTED: "personalize_email_submitted",
  PERSONALIZE_PREVIEW_VIEWED: "personalize_preview_viewed",
  PERSONALIZE_DRAFT_CLAIMED: "personalize_draft_claimed",
  ONBOARDING_COMPLETED: "onboarding_completed",
};

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

export const analytics = {
  track: (event: string, properties: Record<string, unknown>) => {
    console.log("Analytics track event:", event, properties);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: EVENT_PREFIX + event,
      ...properties,
    });
  },
  identify: (userId: string, interests: UserInterest[]) => {
    console.log("Analytics identify user:", userId, interests);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      user_id: userId,
      user_interests: interests,
    });
  },
  reset: () => {
    console.log("Analytics reset");
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      user_id: null,
      user_type: null,
    });
  },
};
